(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9356],{

/***/ 35035:
/***/ (function(module) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),

/***/ 42169:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/harta-site",
      function () {
        return __webpack_require__(1026);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./lib/structuredData.js
var structuredData = __webpack_require__(89229);
;// CONCATENATED MODULE: ./components/BreadcrumbSchema.js




var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, baseUrl = _publicRuntimeConfig.settings.baseUrl;
var BreadcrumbSchema = function(param) {
    var breadcrumbData = param.breadcrumbData, currentPath = param.currentPath;
    // Do not include home page
    // Do not include pages without parent
    if (breadcrumbData && breadcrumbData.length > 1) {
        var itemListElement = breadcrumbData.map(function(breadcrumb, index) {
            return {
                "@type": "ListItem",
                position: index + 1,
                name: breadcrumb.name,
                item: breadcrumb.level != 99 ? "".concat(baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || "") : "".concat(baseUrl).concat(currentPath)
            };
        });
        var schema = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: itemListElement
        };
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: (0,structuredData/* default */.Z)(schema)
            }
        }));
    }
    return null;
};
/* harmony default export */ var components_BreadcrumbSchema = (BreadcrumbSchema);

;// CONCATENATED MODULE: ./components/Breadcrumbs.js








var Breadcrumbs_ref = (0,config["default"])(), settings = Breadcrumbs_ref.publicRuntimeConfig.settings;
var isBricoStore = settings.websiteName === "bricostore";
var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, _isPDP = param.isPDP, isPDP = _isPDP === void 0 ? false : _isPDP, className = param.className;
    var router = (0,next_router.useRouter)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            breadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BreadcrumbSchema, {
                breadcrumbData: breadcrumbs,
                currentPath: router.asPath
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Breadcrumbs is-hidden-in-mobile-app pb-3 lg:py-3 truncate text-sm ".concat(className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                    className: "p-0 m-0 list-none inline",
                    children: breadcrumbs.map(function(breadcrumb, index) {
                        return breadcrumb.level != 99 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: classnames_default()("inline", {
                                "text-red-brand": isBricoStore || !isPDP,
                                "text-[#1D4ED8]": !isBricoStore && isPDP
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "".concat(settings.baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        title: breadcrumb.name,
                                        className: classnames_default()({
                                        }),
                                        children: breadcrumb.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mx-1",
                                    children: "/"
                                })
                            ]
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "inline",
                            children: breadcrumb.name
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index));
                    })
                })
            })
        ]
    }));
};
Breadcrumbs.propTypes = {
    breadcrumbs: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        level: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired,
        url_key: function(props, propName) {
            if (props["level"] !== 99 && (typeof props[propName] !== "string" || props[propName].length === 0)) {
                return new Error("Please provide url_key when item level is not 99.");
            }
        },
        url_suffix: (prop_types_default()).string
    })).isRequired
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 89229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35035);
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__);

// JSON-LD blocks are injected with dangerouslySetInnerHTML, so a "<" coming
// from product data (a "</script>" inside a product name or description) would
// close the script element early and make the whole block unparsable for
// crawlers, besides letting the markup run in the browser. These characters
// are only ever part of JSON string values, where the escaped form is
// equivalent, so escaping them keeps the JSON valid and the page safe.
var HTML_UNSAFE_ESCAPES = {
    "<": "\\u003c",
    ">": "\\u003e",
    "&": "\\u0026"
};
var serializeSchema = function(schema) {
    return fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default()(schema).replace(/[<>&]/g, function(character) {
        return HTML_UNSAFE_ESCAPES[character];
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (serializeSchema);


/***/ }),

/***/ 1026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26209);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11752);
/* harmony import */ var _components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94512);







function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_5__["default"])(), settings = ref.publicRuntimeConfig.settings;
var Sitemap = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(Sitemap, Component1);
    var _super = _createSuper(Sitemap);
    function Sitemap() {
        _classCallCheck(this, Sitemap);
        return _super.apply(this, arguments);
    }
    _createClass(Sitemap, [
        {
            key: "render",
            value: function render() {
                var categories = this.props.categories;
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_3__["default"], {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                                children: "Categorii produse"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            breadcrumbs: [
                                {
                                    id: 1,
                                    level: 99,
                                    name: "Categorii produse"
                                }, 
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "u-heading-section",
                                    children: "Categorii produse"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                    className: "lg-u-grid lg-u-grid-3 u-space-ml-20 lg-u-space-ml-0",
                                    style: {
                                        listStyleType: "upper-roman",
                                        paddingLeft: 0,
                                        lineHeight: "1.8em"
                                    },
                                    children: categories.map(function(level1) {
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            className: "u-color-red lg-u-grid-col",
                                            style: {
                                                display: "list-item",
                                                paddingRight: 25
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "u-color-black u-text-no-underline",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                        href: "".concat(settings.baseUrl, "/").concat(level1.url_key, "/cpl/"),
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            className: "u-display-iblock u-text-linkInherit u-text-hover-underline u-text-size-14 u-text-bold u-text-vertical-top",
                                                            title: level1.name,
                                                            children: level1.name
                                                        })
                                                    })
                                                }),
                                                level1.subcategories && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                    style: {
                                                        listStyleType: "decimal-leading-zero"
                                                    },
                                                    children: level1.subcategories.map(function(level2) {
                                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            className: "u-color-red",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "u-color-black u-text-no-underline",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                                        href: "".concat(settings.baseUrl, "/").concat(level2.url_key, "/cpl/"),
                                                                        passHref: true,
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            className: "u-display-iblock u-text-linkInherit u-text-hover-underline u-text-vertical-top",
                                                                            title: level2.name,
                                                                            children: level2.name
                                                                        })
                                                                    })
                                                                }),
                                                                level2.subcategories && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                    style: {
                                                                        listStyleType: "lower-alpha"
                                                                    },
                                                                    children: level2.subcategories.map(function(level3) {
                                                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            className: "u-color-red",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "u-color-black u-text-no-underline",
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                                                    href: "".concat(settings.baseUrl, "/").concat(level3.url_key, "/cpl/"),
                                                                                    passHref: true,
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                                        className: "u-display-iblock u-text-linkInherit u-text-hover-underline u-text-vertical-top",
                                                                                        title: level3.name,
                                                                                        children: level3.name
                                                                                    })
                                                                                })
                                                                            })
                                                                        }, level3.id);
                                                                    })
                                                                })
                                                            ]
                                                        }, level2.id);
                                                    })
                                                })
                                            ]
                                        }, level1.id);
                                    })
                                })
                            ]
                        })
                    ]
                }));
            }
        }
    ]);
    return Sitemap;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
Sitemap.pageLayout = "default";
/* harmony default export */ __webpack_exports__["default"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .connect */ .$j)(function(state) {
    return {
        categories: state.mainmenu.data
    };
})(Sitemap));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(42169); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);